import { useEffect, useState } from 'react';
import { useIntlayer } from 'react-intlayer';

import { LocalizedLink } from '~/components/LocalizedLink';
import { Button } from '~/components/ui/button';
import { ArrowUpRight } from '~/components/ui/icons';
import { SOCIAL_LINKS } from '~/constants';

export const Header = () => {
  const { chorna, tacticalDrones, jade, joinTeam } = useIntlayer('header');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    // Check initial scroll position on mount
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`flex items-center px-4 py-4 md:px-20 md:py-6 w-full fixed top-0 z-50 transition-colors duration-100 ${isScrolled ? 'bg-black' : ''}`}>
      <div className="flex items-center justify-between w-full">
        <LocalizedLink to="/" className="flex items-center shrink-0">
          <img
            src="/assets/images/trypillian-logo-white-horizontal.svg"
            alt="Logo"
            className="h-5 w-auto md:h-6"
          />
        </LocalizedLink>

        {/* Navigation - Desktop only */}
        <nav className="hidden md:flex items-center gap-3 lg:gap-12">
          <Button variant="tab" asChild>
            <LocalizedLink to="/products/chorna">{chorna}</LocalizedLink>
          </Button>
          <Button variant="tab" asChild>
            <LocalizedLink to="/products/tactical-drones">{tacticalDrones}</LocalizedLink>
          </Button>
          <Button variant="tab" asChild>
            <LocalizedLink to="/products/jade">{jade}</LocalizedLink>
          </Button>
        </nav>

        {/* Right side actions */}
        <div className="flex items-center gap-4">
          {/* Join Team - Desktop only */}
          <Button
            variant="default"
            size="sm"
            className="hidden md:inline-flex"
            onClick={(e) => {
              e.preventDefault();
              window.open(SOCIAL_LINKS.LINKEDIN, '_blank', 'noopener,noreferrer');
            }}
          >
            {joinTeam}
            <ArrowUpRight />
          </Button>

          {/* Menu button - Desktop */}
          {/* <Button
            variant="icon"
            size="icon-34"
            className="hidden md:flex"
            aria-label={openMenu}
          >
            <img src="/assets/images/menu-sm.svg" alt="Menu" />
          </Button> */}

          {/* Menu button - Mobile */}
          {/* <Button
            variant="icon"
            size="icon-30"
            className="flex md:hidden"
            aria-label={openMenu}
          >
            <img src="/assets/images/menu-sm.svg" alt="Menu" />
          </Button> */}
        </div>
      </div>

    </header >
  );
};
